import { render, staticRenderFns } from "./snb2.vue?vue&type=template&id=f5cac936&"
import script from "./snb2.vue?vue&type=script&lang=js&"
export * from "./snb2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports